import axios from '../../../lib/axios-auth.js';

const state = {
    categories: []
};

const getters = {
    /**
     * Retrieves the categories state.
     * @param {object} state - The vuex state.
     * @returns {*}
     */
    categories: state => {
        return state.categories.categories;
    }
};

const mutations = {
    /**
     * Commits the categories content change.
     * @param {object} state - The vuex state.
     * @param {object} payload - The payload object.
     * @returns {void}
     */
    setCategories: (state, payload) => {
        state.categories = payload;
    }
};

const actions = {
    /**
     * Fetches the categories content.
     * @param {object} context - The vuex context object.
     * @param {function} context.commit - The commit method.
     * @param {object} payload - The commit method.
     * @returns {void}
     */
    getCategories: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            axios.get('/api/v2/perks-widget/categories')
                .then(({ data }) => {
                    commit('setCategories', data);
                    resolve(data);
                }).catch(({ response }) => {
                    reject(response);
                });
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
